import axios from 'axios'
import router from '@/router'
import { MdUtils } from '@/utils'

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL
axios.defaults.timeout = 10000

axios.interceptors.request.use(function (config) {
  let token = MdUtils.getTokenPack().AccessToken
  config.headers.token = token
  return config
}, function (error) {
  return Promise.reject(error)
})
axios.interceptors.response.use(function (response) {
  let { Message: message, IsSuccess, ErrorCode, Body } = response.data
  if (!IsSuccess) {
    if (ErrorCode === '0003') {
      return MdUtils.handleError0003(response)
    }
    switch (ErrorCode) {
      case '0001':
        message = message || '基础数据错误，请刷新页面，重新尝试 ！'
        break;
      case '00000':
        message = '操作未成功'
        break;
      case 'Account-LogOnForConnect-NoBind-0001':
        message = '暂无绑定微信，请登录';
        router.replace({
          path: '/login',
          query: { redirect: '/user' }
        })
        break;
      default:
        break;
    }
    return Promise.reject({ message, ErrorCode , Body})
  }

  return response.data
}, function (error) {
  return Promise.reject(error)
})